import { render, staticRenderFns } from "./LinkExpired.vue?vue&type=template&id=ecbe60f6&scoped=true"
import script from "./LinkExpired.vue?vue&type=script&lang=js"
export * from "./LinkExpired.vue?vue&type=script&lang=js"
import style0 from "./LinkExpired.vue?vue&type=style&index=0&id=ecbe60f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbe60f6",
  null
  
)

export default component.exports